module.exports = __webpack_public_path__ + "img/link-extra.3abc4d3.svg";